import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ConfService} from '../../conf.service';
import {AccountInfoService} from '../../user/account-info.service';
import {MatDialog} from '@angular/material/dialog';
import {LeftpanelNewComponent} from '../../leftpanel-new/leftpanel-new.component';
import {LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {Router} from '@angular/router';
import {EmailtemplateService} from '../../emailtemplate.service';
import {environment} from '../../../environments/environment';
import {AddUserGroupComponentComponent} from './add-user-group-component/add-user-group-component.component';
import {AddUserGroupEnvironmentComponentComponent} from './add-user-group-environment-component/add-user-group-environment-component.component';
import {interval} from 'rxjs';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {ViewExclusionsDialogComponent} from '../view-exclusions-dialog/view-exclusions-dialog.component';

@Component({
  selector: 'app-manage-user-groups-new',
  templateUrl: './manage-user-groups-new.component.html',
  styleUrls: ['./manage-user-groups-new.component.scss']
})
export class ManageUserGroupsNewComponent implements OnInit {

  selectedGroup: any;
  displayedColumns: string[] = [
    'actions',
    'environment',
    'users',
    'roles',
    'exclusions',
  ];

  @Input() partner = localStorage.getItem('partner');
  environmentList = [];
  selectedUserList = new FormControl();
  usersList: any;
  selectedRoles = new FormControl();
  partnerName: any;
  userGroups: any;
  rolesList: any;
  searchText: any;
  dataFound: boolean;

  constructor(
      private confPost: ConfService,
      public accountInfoService: AccountInfoService,
      public dialog: MatDialog,
      public platform: LeftpanelNewComponent,
      public _service: ConnecttocrudService,
      public router: Router,
      public emailTemplateInstance: EmailtemplateService,
      private adminEnvironmenthandler: AdminEnvironmentHandlerService,
      private partnerSettingsService: PartnerSettingsService
  ) {}

  getEnvironments() {
    this.confPost.getSettingsV2CRUD(this.partner, this.partner, false).subscribe(response => {
      if (response) {

        for (const item of response['body'][0]['environments']) {
          if (item['type'] !== 'admin') {
            this.environmentList.push(item['name']);
          }
        }
      }
    });
  }

  getUsergroups(softLoader = false) {
    this.dataFound = softLoader;
    const shortName = this.partnerName.split('-');

    let tempSelectedUserGroup: any;
    if (this.selectedGroup) tempSelectedUserGroup = this.selectedGroup;
    this.selectedGroup = null;


    this._service.getItemswithParameter('v1',
        environment.accessPartner,
        environment.accessPartner,
        'usergroups',
        'partner.in=' + shortName[shortName.length - 1]).subscribe(res => {
      if (res) {
        let usergroup: any;
        usergroup = res;
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services&&type.in=platform').subscribe(roles => {
          if (roles) {
            this.rolesList = roles;
            this.rolesList = this.rolesList.filter(value => value['role'] !== 'Platform Admin' && value['role'] !== 'Super Admin' && !value['role'].includes('=>'));
            this._service.getItemswithParameter('v1',
                environment.accessPartner,
                environment.accessPartner,
                'users',
                'partner.in=' + shortName[shortName.length - 1]).subscribe(users => {
              if (users) {
                this.usersList = this.getFilterUserDetails(users);
                for (let user of usergroup) {
                  const elist = [];

                  for (let e of user['environments']) {
                    e['rolesList'] = roles;
                    elist.push(e['name']);
                    const role_list = [];
                    e['platform_roles'] = [];
                    for (const eee of e['rolesList']) {
                      if (eee['role'] !== 'Platform Admin' && eee['role'] !== 'Super Admin' && !eee['role'].includes('=>')) {
                        role_list.push(eee);
                        e['platform_roles'].push(eee['id']);
                      }
                    }
                    e['userlist'] = this.usersList;
                    const user_list = [];
                    e['available_users'] = [];
                    for (const u of e['userlist']) {
                      const shortName = u['user'].split('-');
                      if (shortName[0] !== 'admin') {
                        user_list.push(u);
                        e['available_users'].push(u['id']);
                      }
                    }
                    e['userlist'] = user_list;
                    e['rolesList'] = role_list;
                    e['selected_roles' + e['name']] = e['roles'];
                    e['selected_users' + e['name']] = e['users'];
                    e['user_edit_status'] = true;
                    e['role_edit_status'] = true;
                    e['exlusions_peresent'] = false;
                    if (e['exclusions']['permission_groups'].length > 0) {
                      e['exlusions_peresent'] = true;
                      this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
                        e['exclusions']['permission_groups'] = permissiongroups;
                      });
                    }
                    if (e['exclusions']['permissions'] > 0) {
                      e['exlusions_peresent'] = true;
                      this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
                        e['exclusions']['permissions'] = permissions;
                      });
                    }

                    if (e['exclusions']['roles'] > 0) {
                      e['exlusions_peresent'] = true;
                      this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
                        e['exclusions']['roles'] = roles;
                      });
                    }
                  }
                  user['environmentList'] = elist;
                }

                this.userGroups = usergroup;
                this.selectedGroup = tempSelectedUserGroup ? this.findUserGrpById(tempSelectedUserGroup.id) : usergroup[0];
                this.dataFound = true;
              }
            });
          }
        });
      }
    });

  }

  findUserGrpById(userId) {
    return this.userGroups.find(user => user.id === userId);
  }
  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  toggleExecutor(ev, a) {
    $('.' + a).slideToggle();
    $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
  }

  getFilterUserDetails(userDetails) {
    const ud = [];
    for (const user of userDetails) {
      const shortname = user['user'].split('-');
      if (shortname[0] !== 'admin' && user['status']) {
        ud.push(user);
      }
    }

    return ud;
  }

  openDialog(type): void {
    const dialogRef = this.dialog.open(AddUserGroupComponentComponent, {
      width: '50%',
      panelClass: 'dialog-color',
      data: {
        environments: this.environmentList,
        users: this.usersList,
        roles: this.rolesList,
        groups: this.userGroups
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== '') {
        this.getUsergroups();
      }
    });
  }

  reRoute(id, e) {
    this.router.navigateByUrl('/assign-roles?id=' + id + '&environment=' + e + '&type=userGroup');
  }

  applyUserChanges(i1, i2, id, ngmodelName, users, environments, eName) {

    this.userGroups[i1]['environments'][i2]['user_edit_status'] = true;
    if (this.userGroups[i1]['environments'][i2][ngmodelName]) {
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'usergroups',
          'id=' + id).subscribe(data => {
        const temp = data[0]['environments'][i2]['users'].filter(value => !this.userGroups[i1]['environments'][i2]['available_users'].includes(value));
        data[0]['environments'][i2]['users'] = temp.concat(this.userGroups[i1]['environments'][i2][ngmodelName]);
        this._service.patchItemUpdate(id, {environments: data[0]['environments']},
            'v1', environment.accessPartner,
            environment.accessPartner, 'usergroups').subscribe(async response => {
          if (response) {
            for (const user_id of this.userGroups[i1]['environments'][i2][ngmodelName]) {
              await this.updateUserGroupsInUser(id, user_id);
            }
            for (let u of users) {
              let flag = false;
              if (!this.userGroups[i1]['environments'][i2][ngmodelName].includes(u)) {
                for (let e of environments) {
                  if (e['name'] !== eName && e['users'].includes(u)) {
                    flag = true;
                  }
                }
                if (!flag) {
                  await this.removeUserGroupsInUser(u);
                }
              }
            }
            loaderDialog.close();
            this.platform.openSnackBar(' Environments Updated', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.getUsergroups();
          }

        });
      });

    }
  }

  applyRoleChanges(i1, i2, id, ngmodelName) {
    this.userGroups[i1]['environments'][i2]['role_edit_status'] = true;
    if (this.userGroups[i1]['environments'][i2][ngmodelName]) {
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'usergroups',
          'id=' + id).subscribe(data => {
        const temp = data[0]['environments'][i2]['roles'].filter(value => !this.userGroups[i1]['environments'][i2]['platform_roles'].includes(value));
        data[0]['environments'][i2]['roles'] = temp.concat(this.userGroups[i1]['environments'][i2][ngmodelName]);
        this._service.patchItemUpdate(id, {environments: data[0]['environments']},
            'v1',
            environment.accessPartner,
            environment.accessPartner,
            'usergroups').subscribe(response => {
          if (response) {
            this.platform.openSnackBar(' Environments Updated', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.getUsergroups();
            loaderDialog.close();
          }

        });
      });
    }
  }

  deleteUser(id, name, environments) {
    if (confirm('This action is irreversible, The application role associated with user group environments will also be removed. Are you sure you want to delete this user group?')) {
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      for (const e of environments) {
        this._service.getItemswithParameter('v1',
            environment.accessPartner,
            environment.accessPartner,
            'roles',
            'role=' + e['name'] + '=>' + e['account'] + '=>' + name).subscribe(async res => {
          let roles: any;
          roles = res;
          if (roles && roles.length > 0) {
            await this.deleteRoleForEachEnvironment(roles[0]['id']);
          }
        });
        for (const user_id of e['users']) {
          this._service.getItemswithParameter('v1',
              environment.accessPartner,
              environment.accessPartner,
              'users',
              'id=' + user_id).subscribe(user => {
            if (user && user[0]) {
              let temp: any;
              temp = user[0]['user_groups'];
              const index = temp.indexOf(id);
              temp.splice(index, 1);
              this._service.patchItemUpdate(user[0]['id'],
                  {'user_groups': temp},
                  'v1',
                  environment.accessPartner,
                  environment.accessPartner,
                  'users').subscribe(result => {
              });
            }
          });
        }
      }
      this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(data => {
        this.platform.openSnackBar(' User account deleted successfully', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
        this.selectedGroup = null;
        this.getUsergroups();
      });
    }
  }

  deleteRoleForEachEnvironment(id) {
    return new Promise((resolve, reject) => {
      this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
        if (data) {
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');

      });
    });
  }

  updateUserGroupsInUser(id, user_id) {
    return new Promise((resolve, reject) => {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'users',
          'id=' + user_id).subscribe(resp => {
        if (resp) {
          const user = resp;
          if (!user[0]['user_groups'].includes(id)) {
            user[0]['user_groups'].push(id);
            this._service.patchItemUpdate(user[0]['id'],
                {'user_groups': user[0]['user_groups']},
                'v1',
                environment.accessPartner,
                environment.accessPartner,
                'users').subscribe(updateRes => {
              if (updateRes) {
                resolve('success');
              }
            });
          } else {
            resolve('success');
          }
        }
      });
    });
  }

  removeUserGroupsInUser(user_id) {
    return new Promise((resolve, reject) => {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'users',
          'id=' + user_id).subscribe(user => {
        if (user && user[0]) {
          let temp: any;
          temp = user[0]['user_groups'];
          const index = temp.indexOf(user_id);
          temp.splice(index, 1);
          this._service.patchItemUpdate(user[0]['id'],
              {'user_groups': temp},
              'v1',
              environment.accessPartner,
              environment.accessPartner,
              'users').subscribe(result => {
            if (result) {
              resolve('success');
            } else {
              resolve('failed');
            }
          });
        }
      });
    });
  }

  addEnvironments(userIndex, id, groupName) {
    const environmentList = this.environmentList.filter(value => {
      if (!this.userGroups[userIndex]['environmentList'].includes(value)) {
        return value;
      }
    });

    const dialogRef = this.dialog.open(AddUserGroupEnvironmentComponentComponent, {
      width: '50%',
      panelClass: 'dialog-color',
      data: {
        id: id,
        environmentList: environmentList,
        groupName: groupName,
        userList: this.usersList
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.platform.openSnackBar(' New Environment Added ', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.getUsergroups(true);
      }
    });
  }

  deleteEnvironment(eName, account, groupId, name, users, environments) {
    if (confirm('This action is irreversible, The application role associated with environment will also be removed. Are you sure you want to delete this environment?')) {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'roles',
          'role=' + eName + '=>' + account + '=>' + name).subscribe(async res => {
        const tempRole = res[0];
        if (tempRole) {
          await this.deleteRoleForEachEnvironment(res[0]['id']);
        }

        for (let u of users) {
          let flag = false;
          for (let e of environments) {
            if (e['name'] !== eName && e['users'].includes(u)) {
              flag = true;
            }
          }
          if (!flag) {
            this._service.getItemswithParameter('v1',
                environment.accessPartner,
                environment.accessPartner,
                'users',
                'id=' + u).subscribe(user => {
              if (user && user[0]) {
                let temp: any;
                temp = user[0]['user_groups'];
                const index = temp.indexOf(u);
                temp.splice(index, 1);
                this._service.patchItemUpdate(user[0]['id'],
                    {'user_groups': temp},
                    'v1',
                    environment.accessPartner,
                    environment.accessPartner,
                    'users').subscribe(result => {
                });
              }
            });
          }
        }

        this._service.getItemswithParameter('v1',
            environment.accessPartner,
            environment.accessPartner,
            'usergroups',
            'id=' + groupId).subscribe(data => {
          let environments: any;
          if (data && data[0] && data[0].hasOwnProperty('environments')) {
            environments = data[0]['environments'];
            if (environments.length > 0) {
              const temp = environments.filter(value => value['name'] !== eName);
              this._service.patchItemUpdate(groupId, {environments: temp}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(data => {
                this.platform.openSnackBar(' Environments deleted successfully', 'Success', {
                  duration: 2000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.getUsergroups(true);
              });
            }
          }
        });
      });
    }
  }

  editGroup(i1, i2) {
    this.userGroups[i1]['environments'][i2]['user_edit_status'] = false;
    this.userGroups[i1]['environments'][i2]['role_edit_status'] = false;
  }

  onGroupSelected(group: any) {
    this.selectedGroup = group;
  }

  getGroupIndex(): number {
    return this.userGroups.findIndex(group => group === this.selectedGroup);
  }

  getEnvironmentIndex(element): number {
    return this.selectedGroup['environments'].findIndex(env => env === element);
  }

  cancelEdit(environment: any, field: string) {
    const index = this.selectedGroup['environments'].findIndex((env) => env === environment);
    this.selectedGroup['environments'][index][field] = true;
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  initialize(){
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.partnerSettingsService.environment;
        if (!environmentData.name.includes('admin')) {
          this.redirect('/console');
        } else {
          this.partnerName = localStorage.getItem('partner');
          this.getEnvironments();
          this.getUsergroups();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.partnerSettingsService.environment;
          if (!environmentData.name.includes('admin')) {
            this.redirect('/console');
          } else {
            this.partnerName = localStorage.getItem('partner');
            this.getEnvironments();
            this.getUsergroups();
          }
        });
      }
    }))
  }

  refreshPage(){
    this.initialize();
  }

  ngOnInit() {
    this.initialize();
  }

  viewExclusions(exclusion: any) {
    const dialogRef = this.dialog.open(ViewExclusionsDialogComponent, {
      width: '40%',
      panelClass: 'dialog-color',
      data: {
        title: 'Exclusions',
        element: exclusion
      }
    });
  }
}
